export enum UnitOfMeasures{
    Currency = 'ZAR',
    KWH = 'kWh',
    Days = 'DAYS'
}

export enum ModelVariable {
    modelName = "suspact"
}
